const HOMEPAGE_SCHEMA = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  legalName: 'Opendoor Labs, Inc.',
  alternateName: 'Opendoor',
  url: 'https://www.opendoor.com',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-888-352-7075',
    contactType: 'Customer Service',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'San Francisco',
    addressCountry: 'USA',
    postalCode: '94104',
    streetAddress: '1 Post St, Fl 11',
  },
  logo: 'https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg',
  sameAs: [
    'https://www.facebook.com/OpendoorHQ',
    'https://twitter.com/opendoor',
    'https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw',
    'https://www.linkedin.com/company/opendoor-com',
    'https://www.pinterest.com/opendoorhq',
    'https://en.wikipedia.org/wiki/Opendoor',
  ],
};

export interface GreenhouseJob {
  id: number;
  title: string;
  content: string;
  updated_at: string;
  first_published: string;
  location: { name: string };
  departments: Array<{ id: number; name: string }>;
  offices: Array<{ id: number; name: string; location: string | null }>;
  metadata: Array<{ name: string; value: any }> | null;
}

export const buildJobPostingSchema = (job: GreenhouseJob) => {
  const schema: Record<string, any> = {
    '@context': 'https://schema.org',
    '@type': 'JobPosting',
    title: job.title,
    description: job.content,
    datePosted: job.first_published,
    hiringOrganization: {
      '@type': 'Organization',
      name: 'Opendoor',
      sameAs: 'https://www.opendoor.com',
      logo: HOMEPAGE_SCHEMA.logo,
    },
    jobLocation: {
      '@type': 'Place',
      address: job.location.name,
    },
    jobLocationType: job.location.name.toLowerCase().includes('remote') ? 'TELECOMMUTE' : undefined,
    applicantLocationRequirements: job.location.name.toLowerCase().includes('remote')
      ? [
          { '@type': 'Country', name: 'US' },
          { '@type': 'Country', name: 'Canada' },
        ]
      : undefined,
  };

  // Include baseSalary/employmentType from metadata if Greenhouse is configured with structured fields
  if (job.metadata) {
    const salaryMeta = job.metadata.find((m) =>
      ['salary_range', 'salary', 'compensation'].includes(m.name.toLowerCase()),
    );
    const employmentMeta = job.metadata.find((m) =>
      ['employment_type', 'employment type'].includes(m.name.toLowerCase()),
    );
    if (salaryMeta?.value) schema.baseSalary = salaryMeta.value;
    if (employmentMeta?.value) schema.employmentType = employmentMeta.value;
  }

  // Remove undefined values
  return JSON.parse(JSON.stringify(schema));
};

export { HOMEPAGE_SCHEMA };
